import api from '@/api';

const $api_academic = api.$academic;
const { $report } = api;
const { $exam, $student, $list, $academic, $payment, $user } = $report;

export const { $sellersReporting } = $report
export const { $terms } = $api_academic;
export const $reports = { exam: $exam, student: $student, list: $list, academic: $academic, payment: $payment, user: $user }